import { Controller } from "@hotwired/stimulus"

// Submits a real (non-Turbo) POST navigation from a plain link. Used where a mutating
// action returns a raw file response — Turbo's fetch-based link handling can't hand that
// to the browser's native download behavior, and a plain <a> can't POST on its own.
export default class extends Controller {
  static values = { url: String, method: { type: String, default: "post" } }

  submit(event) {
    event.preventDefault()
    const el = event.currentTarget
    if (el.dataset.disabled === "true") return
    el.dataset.disabled = "true"
    el.classList.add("disabled")
    window.setTimeout(() => {
      el.dataset.disabled = "false"
      el.classList.remove("disabled")
    }, 5000)

    const form = document.createElement("form")
    form.method = "post"
    form.action = this.urlValue
    form.dataset.turbo = "false"
    form.hidden = true

    if (this.methodValue !== "post") {
      const methodInput = document.createElement("input")
      methodInput.type = "hidden"
      methodInput.name = "_method"
      methodInput.value = this.methodValue
      form.append(methodInput)
    }

    const tokenName = document.querySelector('meta[name="csrf-param"]')?.content
    const tokenValue = document.querySelector('meta[name="csrf-token"]')?.content
    if (tokenName && tokenValue) {
      const csrfInput = document.createElement("input")
      csrfInput.type = "hidden"
      csrfInput.name = tokenName
      csrfInput.value = tokenValue
      form.append(csrfInput)
    }

    document.body.append(form)
    form.submit()
  }
}
